export default "__VITE_ASSET__BpZ2LuLE__"